@if (fieldSet.includes(ServiceDataFields.PregnancyInformation)) {
  <section
    *appRequirePermission="id ? ['medicalInformation'] : []"
    [attr.data-cy]="ServiceDataFields.PregnancyInformation + '-section'"
  >
    <p class="caption mb-1">
      {{ 'serviceData.form.currentPregnancy' | translate }}
    </p>
    <hr class="mt-0" />
    @if (fieldSet.includes(ServiceDataFields.PregnancyStatus)) {
      <ng-container formGroupName="galleri">
        <ng-container formGroupName="currentPregnancyInformation">
          <app-service-data-form-condition-history
            [config]="{
              type: RadioFormType.Single,
              answerProperty: 'isPregnant',
              title: {
                question: 'serviceData.form.galleri.isPregnant' | translate,
              },
              validationTranslation: {
                answer: 'serviceData.form.validation.galleri',
              },
            }"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.PregnancyStatus"
          />
        </ng-container>
      </ng-container>
    }
    <ng-container formGroupName="shared">
      <ng-container formGroupName="currentPregnancyInformation">
        <app-service-data-form-gestation-age [fieldSet]="fieldSet" />

        <app-service-data-form-pregnancy-type [fieldSet]="fieldSet" />

        <app-service-data-form-in-vitro [fieldSet]="fieldSet" />

        <app-service-data-form-vanishing-twin-syndrome [fieldSet]="fieldSet" />

        <ng-container formGroupName="heparinTherapy">
          <app-service-data-form-condition-history
            [config]="{
              type: RadioFormType.Double,
              title: {
                question:
                  'serviceData.form.heparinTherapy.hasReceived' | translate,
                subQuestion:
                  'serviceData.form.heparinTherapy.isRelevant'
                  | translate: { hours: 24 },
              },
              validationTranslation: {
                subAnswer: 'serviceData.form.validation.heparinTherapy',
              },
            }"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.HeparinTherapy"
          />
        </ng-container>

        @if (fieldSet.includes(ServiceDataFields.DateOfUltrasound)) {
          <div class="row">
            <div
              class="col-12 col-md-6 mb-3"
              [attr.data-cy]="ServiceDataFields.DateOfUltrasound"
            >
              <div class="row align-items-center">
                <div class="col-12 col-sm-4 mb-1">
                  <label for="ultrasoundDate">{{
                    'serviceData.form.ultrasoundDate' | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-8">
                  <input
                    ngbDatepicker
                    class="form-control"
                    formControlName="ultrasoundDate"
                    id="ultrasoundDate"
                    appInputValidationStatus
                    container="body"
                    #ultrasoundDatepicker="ngbDatepicker"
                    [attr.data-cy]="
                      ServiceDataFields.DateOfUltrasound + '-input'
                    "
                    [placeholder]="
                      'serviceData.form.placeholders.dateFormat' | translate
                    "
                    (click)="ultrasoundDatepicker.toggle()"
                  />
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-8">
                  <app-validation-error
                    for="ultrasoundDate"
                    translations="validation.generic"
                    [attr.data-cy]="
                      ServiceDataFields.DateOfUltrasound + '-validation-error'
                    "
                  ></app-validation-error>
                </div>
              </div>
            </div>
          </div>
        }
      </ng-container>
    </ng-container>

    <ng-container formGroupName="nipt">
      <ng-container formGroupName="currentPregnancyInformation">
        <app-service-data-form-prior-screening-test [fieldSet]="fieldSet" />
      </ng-container>
    </ng-container>
  </section>
}
